import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Music, Phone, Menu, X, ChevronDown } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCollectionOpen, setIsCollectionOpen] = useState(false);

  return (
    <header className="nav-modern fixed top-0 left-0 right-0 z-50 transition-all duration-300">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <div className="flex items-center space-x-2 sm:space-x-3 min-w-0 flex-shrink">
            <div className="animate-glow-pulse flex-shrink-0">
              <Music className="w-6 h-6 sm:w-8 sm:h-8 text-yellow-400" />
            </div>
            <div className="text-lg sm:text-2xl truncate">
              <span className="font-light text-white">Musique</span>
              <span className="heading-accent font-semibold ml-1 sm:ml-2">Buchta</span>
            </div>
          </div>

          {/* Navigation Desktop */}
          <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8 flex-shrink">
            <Link to="/" className="text-white hover:text-yellow-400 transition-colors duration-300 whitespace-nowrap text-sm xl:text-base">
              Accueil
            </Link>

            {/* Menu Collection avec dropdown */}
            <div
              className="relative"
              onMouseEnter={() => setIsCollectionOpen(true)}
              onMouseLeave={() => setIsCollectionOpen(false)}
            >
              <button className="flex items-center space-x-1 text-white hover:text-yellow-400 transition-colors duration-300 whitespace-nowrap text-sm xl:text-base">
                <span>Collection</span>
                <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${isCollectionOpen ? 'rotate-180' : ''}`} />
              </button>

              {/* Dropdown Menu */}
              <div className={`absolute top-full left-0 mt-2 w-56 bg-black/95 backdrop-blur-md border border-yellow-400/30 rounded-lg shadow-2xl transition-all duration-300 ${
                isCollectionOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'
              }`}>
                <div className="p-4 space-y-4">
                  <Link
                    to="/pianos-numeriques-neufs"
                    className="block px-4 py-3 text-white hover:text-yellow-400 hover:bg-yellow-400/10 rounded-md transition-all duration-300 font-medium"
                  >
                    Piano Numérique
                  </Link>
                  <Link
                    to="/pianos-queue-droit-neufs"
                    className="block px-4 py-3 text-white hover:text-yellow-400 hover:bg-yellow-400/10 rounded-md transition-all duration-300 font-medium"
                  >
                    Piano Acoustique
                  </Link>
                </div>
              </div>
            </div>

            <Link to="/services" className="text-white hover:text-yellow-400 transition-colors duration-300 whitespace-nowrap text-sm xl:text-base">
              Services
            </Link>
            <Link to="/histoire" className="text-white hover:text-yellow-400 transition-colors duration-300 whitespace-nowrap text-sm xl:text-base">
              Histoire
            </Link>
            <Link to="/locations" className="text-white hover:text-yellow-400 transition-colors duration-300 whitespace-nowrap text-sm xl:text-base">
              Location
            </Link>
            <Link to="/galerie" className="text-white hover:text-yellow-400 transition-colors duration-300 whitespace-nowrap text-sm xl:text-base">
              Galerie
            </Link>
            <a href="/#contact" className="text-white hover:text-yellow-400 transition-colors duration-300 whitespace-nowrap text-sm xl:text-base">
              Contact
            </a>
          </nav>

          {/* Bouton Téléphone */}
          <div className="hidden lg:flex items-center flex-shrink-0">
            <a
              href="tel:+33389542003"
              className="btn-premium px-4 xl:px-6 py-2 xl:py-3 rounded-full flex items-center space-x-2 transition-all duration-300 text-sm xl:text-base whitespace-nowrap"
            >
              <Phone className="w-3 h-3 xl:w-4 xl:h-4 flex-shrink-0" />
              <span className="font-semibold">03 89 54 20 03</span>
            </a>
          </div>

          {/* Menu Mobile Toggle */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-white hover:text-yellow-400 transition-colors duration-300 flex-shrink-0 p-2"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Menu Mobile */}
        <div className={`lg:hidden transition-all duration-300 overflow-hidden ${
          isMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}>
          <nav className="py-4 space-y-3 border-t border-yellow-400/20">
            <Link
              to="/"
              onClick={() => setIsMenuOpen(false)}
              className="block text-white hover:text-yellow-400 transition-colors duration-300 py-2"
            >
              Accueil
            </Link>
            <div className="space-y-2">
              <span className="block text-yellow-400 font-semibold py-2">Collection</span>
              <div className="pl-4 space-y-2">
                <Link
                  to="/pianos-numeriques-neufs"
                  onClick={() => setIsMenuOpen(false)}
                  className="block text-white hover:text-yellow-400 transition-colors duration-300 py-2"
                >
                  Piano Numérique
                </Link>
                <Link
                  to="/pianos-queue-droit-neufs"
                  onClick={() => setIsMenuOpen(false)}
                  className="block text-white hover:text-yellow-400 transition-colors duration-300 py-2"
                >
                  Piano Acoustique
                </Link>
              </div>
            </div>
            <Link
              to="/services"
              onClick={() => setIsMenuOpen(false)}
              className="block text-white hover:text-yellow-400 transition-colors duration-300 py-2"
            >
              Services
            </Link>
            <Link
              to="/histoire"
              onClick={() => setIsMenuOpen(false)}
              className="block text-white hover:text-yellow-400 transition-colors duration-300 py-2"
            >
              Histoire
            </Link>
            <Link
              to="/locations"
              onClick={() => setIsMenuOpen(false)}
              className="block text-white hover:text-yellow-400 transition-colors duration-300 py-2"
            >
              Location
            </Link>
            <Link
              to="/galerie"
              onClick={() => setIsMenuOpen(false)}
              className="block text-white hover:text-yellow-400 transition-colors duration-300 py-2"
            >
              Galerie
            </Link>
            <a
              href="/#contact"
              onClick={() => setIsMenuOpen(false)}
              className="block text-white hover:text-yellow-400 transition-colors duration-300 py-2"
            >
              Contact
            </a>
            <a
              href="tel:+33389542003"
              className="btn-premium px-6 py-3 rounded-full flex items-center justify-center space-x-2 transition-all duration-300 w-full mt-4"
            >
              <Phone className="w-4 h-4 flex-shrink-0" />
              <span className="font-semibold">03 89 54 20 03</span>
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;